module.exports = __webpack_public_path__ + "assets/img/6.652cb8cb.png";